import FileIcon from "../../FileIcon";
import styles from "./index.less";
import { message } from "antd";
import { FileMessage as FileMessageType } from "../types";

type FileProps = {
  msg: FileMessageType;
};
const FileMessage = (props: FileProps) => {
  const { msg } = props;
  const { url, name } = msg;

  const handleOpenFile = () => {
    if (url) {
      window.open(url);
    } else {
      message.error("没有文件链接无法打开");
    }
  };

  // const handleDownLoadFile = () => {
  //   fetch(url)
  //     .then((res) => res.blob()) // 转换为Blob对象
  //     .then((blob) => {
  //       const href = URL.createObjectURL(blob); // 创建Blob URL
  //       const link = document.createElement('a');
  //       link.href = href;
  //       link.download = fileName; // 设置下载的文件名，根据实际情况修改
  //       document.body.appendChild(link);
  //       link.click(); // 模拟点击
  //       document.body.removeChild(link); // 下载完成后移除元素
  //       URL.revokeObjectURL(href); // 释放Blob URL
  //     })
  //     .catch((e) => console.error(e));
  // };

  return (
    <div className={styles["content-file"]}>
      <div
        className={styles["content-file-container"]}
        onClick={handleOpenFile}
      >
        <div className={styles["file-name"]}>
          <div className={styles["file-item-name"]}>{name}</div>
          {/* <div className={styles['file-item-size']}>
            {file_size !== undefined ? formatFilesSize(file_size) : '未知大小'}
          </div> */}
        </div>
        <div className={styles["file-icon"]}>
          <FileIcon fileName={name} />
        </div>
      </div>
    </div>
  );
};

export default FileMessage;
